import { jsx as b } from "react/jsx-runtime";
import { c as n } from "./clsx.OuTLNxxd.js";
const m = ({
  className: d,
  type: e = "horizontal",
  size: r = "1x",
  margin: a = "4",
  color: o = "gray"
}) => {
  const t = n([
    e === "vertical" && `h-100 border-left mx-${a}`,
    e === "horizontal" && `w-100 border-top my-${a}`,
    r === "1x" && "border-1",
    r === "2x" && "border-2",
    r === "3x" && "border-3",
    r === "4x" && "border-4",
    o === "gray" && "border-neu-gray-10",
    o === "gray-30" && "border-neu-gray-30",
    o === "main" && "border-neu-main",
    o === "support" && "border-neu-support",
    d
  ]);
  return /* @__PURE__ */ b("div", { className: t });
};
export {
  m as D
};
